import Cookies from "universal-cookie";

const MyCookies = new Cookies();

export default MyCookies;
